/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Article_Unpublished_SuccessInputs */

const en_toast_article_unpublished_success = /** @type {(inputs: Toast_Article_Unpublished_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article unpublished successfully`)
};

const nl_toast_article_unpublished_success = /** @type {(inputs: Toast_Article_Unpublished_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikelpublicatie succesvol ongedaan gemaakt`)
};

/**
* | output |
* | --- |
* | "Article unpublished successfully" |
*
* @param {Toast_Article_Unpublished_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_article_unpublished_success = /** @type {((inputs?: Toast_Article_Unpublished_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Article_Unpublished_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_article_unpublished_success(inputs)
	return en_toast_article_unpublished_success(inputs)
});